<template>
  <div class="Index">
    <div class="container">
      <div class="topBorder">
        <ul>
          <li :class="Type == 0 ?'borColor':''" @click="wayTypeUrl(0)">
            <img src="@/assets/images/Frame 36@2x.png" alt="">
            <span>配料查</span>
          </li>
          <li :class="Type == 1 ?'borColor':''" @click="wayTypeUrl(1)">
            <img src="@/assets/images/lve.png" alt="" style="border-radius: 50%;">
            <span>赚赚驴</span>
          </li>
          <li :class="Type == 2 ?'borColor':''" @click="wayTypeUrl(2)">
            <img src="@/assets/images/1024-1@2x (2).png" alt="">
            <span>赚赚狗</span>
          </li>
        </ul>
      </div>
      <!-- 配料查 -->
      <div v-if="Type == 0">
        <div><img src="@/assets/images/Title1@2x.png" class="conTitle" alt=""></div>
        <div class="conJianj">
          <p>智能、高效、全面的搜索体验，找添加剂、找配料</p>
          <p>做你生活，工作的高效助手</p>

          <div class="conUrlbtn">
            <img src="@/assets/images/Group 34756@2x.png" alt="" @click="wayISIOS">
            <span style="width: 20px;display: inline-block;"></span>
            <img src="@/assets/images/Group 34765@2x.png" alt=""  @click="wayISANDRoid">
          </div>
          <div class="conUrlbtnH5">
            <img src="@/assets/images/Group 34762@2x.png" alt="" @click="wayIs">
          </div>
          <div class="conPcimg">
            <img class="" src="@/assets/images/Group 34771@2x.png" alt="">
          </div>
          <div class="conH5img">
            <img class="" src="@/assets/images/h5/iPhone1 1 2@2x.png" alt="">
          </div>
        </div>
      </div>

      <!-- 赚赚驴 -->
      <div v-else-if="Type == 1" style="padding-top:20px">
        <div><img src="@/assets/images/Title1@2x_23.png" class="conTitle" alt=""></div>
        <div class="conJianj">
          <p>全新的健康生活管理APP</p>
          <p>助您打造健康与财富兼得的生活！</p>

          <div class="conUrlbtn">
            <img src="@/assets/images/Group 34756@2x3.png" alt="" @click="wayISIOS">
            <span style="width: 20px;display: inline-block;"></span>
            <img src="@/assets/images/Group 34765@2x3.png" alt=""  @click="wayISANDRoid">
          </div>
          <div class="conUrlbtnH5">
            <img src="@/assets/images/Group 34762@2x.png" alt="" @click="wayIs">
          </div>
          <div class="conPcimg">
            <img class="" src="@/assets/images/Group 347652@2x.png" alt="">
          </div>
          <!-- <div class="conPcimg2">
            <img class="" src="@/assets/images/iPhone1 1 2@2x (2).png" alt="">
          </div>
          <div class="conH5img">
            <img class="" src="@/assets/images/iPhone1 1 2@2x (2).png" alt="">
          </div> -->
         
          <div class="conH5img">
            <img class="" src="@/assets/images/h5/iPhone1 1 2@2x2.png" alt="">
          </div>
        </div>
      </div>
      <!-- 赚赚狗 -->
      <div v-else-if="Type == 2">
        <div><img src="@/assets/images/Title11@2x22.png" class="conTitle" alt=""></div>
        <div class="conJianj">
          <p>适合自由职业者/斜杠青年找工作</p>
          <p>白天上班工作晚上居家副业</p>

          <div class="conUrlbtn">
            <img src="@/assets/images/Group 347561@2x.png" alt="" @click="wayISIOS">
            <span style="width: 20px;display: inline-block;"></span>
            <img src="@/assets/images/Group 347651@2x.png" alt="" @click="wayISANDRoid">
          </div>
          <div class="conUrlbtnH5">
            <img src="@/assets/images/Group 34762@2x.png" alt="" @click="wayIs">
          </div>
          <div class="conPcimg">
            <img class="" src="@/assets/images/dog@2x.png" alt="">
          </div>
          <div class="conH5img">
            <img class="" src="@/assets/images/h5/iPhone1 11 2@2x2.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="Footer">
      <ul v-if="Type != 0">
        <li @click="wayRouter('privacy_copy')">隐私政策</li>
        <li class="line">|</li>
        <li @click="wayRouter('agreement_copy')">用户协议</li>
      </ul>
      <ul v-if="Type == 0">
        <li @click="wayRouter('privacy')">隐私政策</li>
        <li class="line">|</li>
        <li @click="wayRouter('agreement')">用户协议</li>
      </ul>
      <ul>
        <li>商务合作： kurt960916@gmail.com</li>
        <li class="line">|</li>
        <li>联系我们： kurt960916@gmail.com</li>
      </ul>
      <ul>
        <li> © 2019-2025 版权所有 京ICP备2025103902号</li>
      </ul>
    </div>
  </div>
</template>

<script setup name='Index'>
import { onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router';
import axios from 'axios';
const router = useRouter()
const Type = ref(0) // 分类  0-配料查 、1-赚赚驴、2-赚赚狗
const TypeOne2 = ref('https://www.peiliaocha.com/download/peiliaocha.apk')
const TypeOne = ref('https://apps.apple.com/cn/app/%E9%85%8D%E6%96%99%E6%9F%A5-%E9%A3%9F%E5%93%81%E9%85%8D%E6%96%99%E8%A1%A8%E6%B7%BB%E5%8A%A0%E5%89%82%E6%88%90%E4%BB%BD%E6%89%AB%E6%8F%8F%E6%9F%A5%E8%AF%A2/id6737591700')
const TypeTwo = ref('https://apps.apple.com/cn/app/%E8%B5%9A%E8%B5%9A%E9%A9%B4-%E8%AE%A9%E8%B5%9A%E9%92%B1%E5%8F%98%E5%BE%97%E6%9B%B4%E7%AE%80%E5%8D%95/id6737188481')
const TypeThree = ref('https://apps.apple.com/cn/app/%E8%B5%9A%E8%B5%9A%E7%8B%97-%E8%AE%A9%E7%94%9F%E6%B4%BB%E6%9B%B4%E5%BF%AB%E4%B9%90/id6740019646')

// 跳转新页面URL
const wayTypeUrl = (EV)=>{
  switch(EV){
    case 0:
      window.open(PostsURL.value.plcUrl)
      break;
    case 1:
    window.open(PostsURL.value.zzlUrl)
      break
    case 2:
    window.open(PostsURL.value.zzgUrl)
      break
    default:
  }
}

// 请求跳转页面路径URL
const PostsURL = ref({})
const fetchPosts = async () => {
      try {
        const response = await axios.post('https://www.zhuanzhuangou.com/Login/getTgUrl');
        console.log('response',response)
        PostsURL.value = response.data.data;
      } catch (err) {
        console.log('接口错误',err)
      }
    };


// 动态设置页面Title
watch(Type,(newValue, oldValue)=>{
  waySwitch(oldValue)
})
const waySwitch = (oldValue)=>{
  switch(oldValue){
    case 0:
      document.title = '配料查';
      break
    case 1:
      document.title = '赚赚驴';
      break
    case 2:
      document.title = '赚赚狗';
      break
    default:
  }
}

// 判断设备型号
function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}
function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}
// 立即下载
const wayIs = ()=>{
  if (isIOS()) {
      // 跳转到App Store
      wayISIOS()
    } else if (isAndroid()) {
      // 跳转到Google Play Store
      // window.location.href = 'https://play.google.com/store/apps/details?id=YOUR_APP_PACKAGE_NAME';
      wayISANDRoid()
    } else {
      // 如果不是移动设备，跳转到H5页面
      // window.location.href = 'https://your-h5-website.com';
      wayISIOS()
    }
}
// PC 跳转Android
const wayISANDRoid = ()=>{
  // window.open(TypeOne2.value)
  window.location.href = TypeOne2.value;
  // window.alert('安卓上线中,敬请期待！')
}
// PC 跳转IOS
const wayISIOS = ()=>{
  if(Type.value == 0){
     window.open(TypeOne.value)
  }else if(Type.value == 1){
    window.open(TypeTwo.value)
  }else if(Type.value == 2){
    window.open(TypeThree.value)
  }
 
}


// 跳转协议内容
const wayRouter = (name) => {
  router.push({
    name
  })
}
onMounted(()=>{
  fetchPosts()
  waySwitch(Type.value)
})
</script>

<style lang='scss' scoped>
.Index {
  display: flex;
  align-items: center;
  flex-direction: column;
  background: linear-gradient(180deg, #EFF1F3 0%, #FFFFFF 100%);

  @media (min-width:700px) {

    .container {
      text-align: center;
     
      .topBorder {
        ul {
          width: 420px;
          border-radius: 50px;
          background-color: #e6e8ea;
          margin: 20px auto 40px;
          border: 1px solid #ffffff;
          padding: 5px 8px;
          box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2), -5px -5px 10px rgba(0, 0, 0, 0.2);
          display: flex;
          align-items: center;
          justify-content: space-between;

          .borColor {
            background-color: #ffffff;
            padding: 6px 10px;
            border-radius: 50px;
            color: #000000;
          }

          li {
            display: flex;
            align-items: center;
            color: #979a9b;
            cursor: pointer;
            font-weight: 500;
            padding: 6px 10px;

            img {
              width: 26px;
              height: 26px;
              margin-right: 5px;
            }
          }
        }
      }

      .conTitle {
        width: 334px;
      }

      .conJianj {
        color: #666666;
        font-size: 20px;
        text-align: center;

        p {
          margin: 10px 0;
        }
      }

      .conPcimg {
        img {
          width: 666px;
        }
      }
      .conPcimg2 {
        img {
          width: 280px;
        }
      }

      .conH5img {
        display: none;
      }

      .conUrlbtn {
        padding: 20px 0;

        img {
          width: 216px;
          cursor: pointer;
        }
      }

      .conUrlbtnH5 {
        display: none;
      }
    }

    .Footer {
      width: 100%;
      padding: 20px 0;
      border-top: 1px solid #F5F6F9;
      font-size: 13px;
      color: #ACACAC;

      ul:nth-of-type(2) {
        margin: 10px 0;
      }

      ul {
        display: flex;
        justify-content: center;

        .line {
          padding: 0 10px;
        }

        li {
          cursor: pointer;
        }
      }
    }
  }

  @media (max-width:700px) {

    .container {
      text-align: center;
      .conPcimg2{
        display: none;
      }
      .topBorder {
        ul {
          width: 320px;
          border-radius: 50px;
          background-color: #e6e8ea;
          margin: 20px auto 40px;
          border: 1px solid #ffffff;
          padding: 5px 8px;
          box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2), -5px -5px 10px rgba(0, 0, 0, 0.2);
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .borColor {
            background-color: #ffffff;
            padding: 4px 8px;
            border-radius: 50px;
            color: #000000;
          }

          li {
            display: flex;
            align-items: center;
            color: #979a9b;
            cursor: pointer;
            font-weight: 500;
            padding: 6px 10px;

            img {
              width: 23px;
              height: 23px;
              margin-right: 5px;
            }
          }
        }
      }

      .conTitle {
        width: 334px;
      }

      .conJianj {
        color: #666666;
        font-size: 16px;
        text-align: center;
        margin-top: 20px;

        p {
          margin: 10px 0;
        }
      }

      .conPcimg {
        display: none;

        img {
          width: 666px;
        }
      }
  
      .conH5img {
        margin: 20px 0 0;

        img {
          width: 265px;
        }

      }

      .conUrlbtn {
        display: none;
        padding: 20px 0;

        img {
          width: 216px;
          cursor: pointer;
        }
      }

      .conUrlbtnH5 {
        margin: 20px 0;

        img {
          width: 156px;
        }
      }

    }

    .Footer {
      width: 100%;
      padding: 20px 0;
      border-top: 1px solid #F5F6F9;
      font-size: 13px;
      color: #ACACAC;

      ul:nth-of-type(2) {
        flex-direction: column;
        align-items: center;

        .line {
          display: none;
        }
      }

      ul {
        display: flex;
        justify-content: center;
        margin: 10px 0;

        .line {
          padding: 0 10px;
        }

        li {
          cursor: pointer;
        }
      }
    }
  }
}
</style>